import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { BigNumber } from 'ethers';
import * as winners from './winners';
import lootboxes from './winners/lootboxes.json'
// import { number } from '@amcharts/amcharts4/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { TokenService } from 'app/services/contract/contracts-services/token.service';
import { StakingRewardsLPService, StakingRewardsOldService, StakingRewardsService } from 'app/services/contract/contracts-services/staking-rewards.service';
import { LotteryOldService, LotteryService } from 'app/services/contract/contracts-services/lottery.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { eContracts } from 'app/services/contract/contract.config';
import { LiquidityProviderService } from 'app/services/contract/contracts-services/liquidity-provider.service';
declare const analytics

interface httpResult {
  status
  data
  description
}

interface Kryptomons {
  image
  type
  talent
  typeFormatted
  xfactor
  speciality
  timeBorn
  super
  personality
  generation
  id
  islandImage
  timeBornUnix
  unfreezable
  bio
}

interface Personality {
  Constitution
  Affection
  Crazyness
  Instinct
  Hunger
  Laziness
  Braveness
  Smart
  Ego
  generation
}

@Component({
  selector: 'app-staking',
  templateUrl: './staking.component.html',
  styleUrls: ['./staking.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StakingComponent implements OnInit, OnDestroy {

  public showContent
  public showContentLP
  public selectedAmountUI
  public selectedAmountUILP
  public rangeValue
  public rangeValueLP
  public ticketsAvailable
  public ticketsAvailableLP
  public ticketsPlayed
  public win
  public noWin
  public kmonStaked
  public haveParticipated: boolean
  public haveWon
  // public accounts
  public balance
  public kmonToBeStaked
  public ticketsAvailableWei
  public ticketsAvailableWeiLP
  public kmonToBeWithdraw
  public lpToBeWithdraw
  public kmonStakedWei
  public kmonBalance
  public isLoading
  public isLoadingLP
  public totalKMONStaked
  public totalKMONStakedV1
  public totalKMONStakedWeiV1: BigNumber
  public totalKMONStakedWei: BigNumber
  public totalLPStaked
  public totalLPStakedWei: BigNumber
  public playDisabled
  public playDisabledLP
  public selectedTicketPlayed
  public playersInLottery
  public isApproved
  public isApprovedLP
  public lotteryStatus
  public ticketsPlayedUser
  public rewardRate: BigNumber
  public rewardRateLP: BigNumber
  public winningClaims
  public isLoadingCollect
  public collectedKryptomon
  public showShare
  public kryptomons
  public typeFormatted = ["Fire", "Water", "Ice", "Ground", "Air", "Electro", "Ghost", "Grass"];
  public submittingWinners;
  public haveMigrated
  public kmonStakedOldWei
  public kmonStakedOld
  public migrationRunning
  public accumulationStarted
  public balanceLP
  public lpBalance
  public lpToBeStaked
  public lpStakedWei
  public lpStaked
  public lootboxesObject
  public hasLootboxes
  public weeklyRewardRate
  public oldCandiesAvailable
  public oldCandiesAvailableWei
  public hasOldCandies;
  wallet: string
  StakingRewardsOldAddress: string = eContracts.StakingRewardsOld
  checkBalanceInterval: NodeJS.Timeout;

  constructor(
    private http: HttpClient,
    private router: Router,
    private toastService: ToastService,
    private userService: UserService,
    private web3Service: Web3Service,
    private tokenService: TokenService,
    private stakingRewardsService: StakingRewardsService,
    private stakingRewardsLPService: StakingRewardsLPService,
    private stakingRewardsOldService: StakingRewardsOldService,
    private lotteryService: LotteryService,
    private lotteryOldService: LotteryOldService,
    private contractsService: ContractsService,
    private liquidityProviderService: LiquidityProviderService
  ) {

    this.showContent = [false, false, true];
    this.showContentLP = [false, false, true];
    this.selectedAmountUI = [false, false, false, false]
    this.selectedAmountUILP = [false, false, false, false]
    this.rangeValue = 0;
    this.weeklyRewardRate = 0;
    this.rangeValueLP = 0;
    this.ticketsAvailable = 0;
    this.ticketsAvailableLP = 0;
    this.ticketsPlayed = 0;
    this.win = true;
    this.noWin = false;
    this.haveParticipated = false;
    this.haveWon = false; //false
    this.showShare = false;
    this.kmonStaked = 0;
    this.kmonToBeStaked = 0;
    this.kmonToBeWithdraw = 0;
    this.lpToBeWithdraw = 0;
    this.isLoading = false;
    this.isLoadingLP = false;
    this.totalKMONStaked = 0;
    this.totalLPStaked = 0;
    this.lpStaked = BigNumber.from(0);
    this.totalLPStakedWei = BigNumber.from(0);
    this.totalKMONStakedWei = BigNumber.from(0);
    this.totalKMONStakedV1 = 0;
    this.totalKMONStakedWeiV1 = BigNumber.from(0);
    this.kmonBalance = 0;
    this.playDisabled = true;
    this.playDisabledLP = true;
    this.selectedTicketPlayed = 0;
    this.playersInLottery = 0;
    this.isApproved = false;
    this.isApprovedLP = false;
    this.ticketsPlayedUser = 0;
    this.rewardRate = BigNumber.from(0);
    this.rewardRateLP = BigNumber.from(0);
    this.winningClaims = [];
    this.isLoadingCollect = false; //false
    this.collectedKryptomon = false;
    this.kryptomons = [];
    this.submittingWinners = false;
    this.haveMigrated = true;
    this.kmonStakedOldWei = 0;
    this.kmonStakedOld = 0;
    this.migrationRunning = false;
    this.accumulationStarted = true;
    this.lpToBeStaked = 0;
    this.balanceLP = 0;
    this.lpBalance = 0;
    this.lpStakedWei = 0;
    this.lpStaked = 0;
    this.lootboxesObject = lootboxes;
    this.hasLootboxes = false;
    this.oldCandiesAvailable = 0;
    this.oldCandiesAvailableWei = 0;
    this.hasOldCandies = false;

    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe((accounts) => {
    //     this.accounts = accounts;
    //     console.log(this.accounts[0])
    //     if (this.accounts[0] !== undefined && this.accounts[0] !== "") {
    //       this.checkAllowance()
    //       this.checkAllowanceLP()
    //       this.checkBalance()
    //       setInterval(() => {
    //         this.checkBalance();
    //       }, 5000)
    //     }
    //   });
    // } else {
    // this.accounts = this.appComponent.accounts;

    this.wallet = this.userService._userInfoData.recordedWallet;
    this.checkAllowance()
    this.checkAllowanceLP()
    this.checkBalance()
    this.checkBalanceInterval = setInterval(() => {
      this.checkBalance();
    }, 5000)
    // }
  }
  ngOnDestroy(): void {
    if (this.checkBalanceInterval) {
      clearInterval(this.checkBalanceInterval);
    }
  }


  // async getAccounts() {
  //   this.accounts = await this.contractService.web3.eth.getAccounts().then((accounts) => {
  //     console.log(accounts)
  //     return accounts;
  //   }).catch((err) => {
  //     ////console.log(err, 'err!!');
  //   });
  //   if (this.accounts.length == 0) {
  //     //this.connection_text = "Grant access";
  //   } else {
  //     //this.connection_text = "Connected";
  //   }
  // }

  async checkBalance() {

    this.checkLotteryStatus()

    this.balance = await this.tokenService.contract.methods.balanceOf(this.wallet).call();
    this.kmonBalance = this.web3Service.getWeb3().utils.fromWei(this.balance)

    this.balanceLP = await this.liquidityProviderService.contract.methods.balanceOf(this.wallet).call();
    this.lpBalance = this.web3Service.getWeb3().utils.fromWei(this.balanceLP)

    this.kmonStakedWei = BigNumber.from(await this.stakingRewardsService.contract.methods.balanceOf(this.wallet).call());
    this.kmonStaked = this.web3Service.getWeb3().utils.fromWei(this.kmonStakedWei.toString())

    this.lpStakedWei = BigNumber.from(await this.stakingRewardsLPService.contract.methods.balanceOf(this.wallet).call());
    this.lpStaked = this.web3Service.getWeb3().utils.fromWei(this.lpStakedWei.toString())

    this.kmonStakedOldWei = BigNumber.from(await this.stakingRewardsOldService.contract.methods.balanceOf(this.wallet).call());
    this.kmonStakedOld = this.web3Service.getWeb3().utils.fromWei(this.kmonStakedOldWei.toString())

    this.totalKMONStakedWei = BigNumber.from(await this.stakingRewardsService.contract.methods.totalSupply().call());
    this.totalKMONStaked = Math.floor(this.web3Service.getWeb3().utils.fromWei(this.totalKMONStakedWei.toString()));

    this.totalLPStakedWei = BigNumber.from(await this.stakingRewardsLPService.contract.methods.totalSupply().call());
    this.totalLPStaked = Math.floor(this.web3Service.getWeb3().utils.fromWei(this.totalLPStakedWei.toString()));

    this.totalKMONStakedWeiV1 = BigNumber.from(await this.stakingRewardsOldService.contract.methods.totalSupply().call());
    this.totalKMONStakedV1 = Math.floor(this.web3Service.getWeb3().utils.fromWei(this.totalKMONStakedWeiV1.toString()));

    let ticketEarned = await this.stakingRewardsService.contract.methods.earned(this.wallet).call();
    this.ticketsAvailable = parseFloat(this.web3Service.getWeb3().utils.fromWei(ticketEarned)).toFixed(5);
    this.ticketsAvailableWei = this.web3Service.getWeb3().utils.fromWei(ticketEarned)

    let oldCandiesEarned = await this.stakingRewardsOldService.contract.methods.earned(this.wallet).call();
    this.oldCandiesAvailable = parseFloat(this.web3Service.getWeb3().utils.fromWei(oldCandiesEarned)).toFixed(5);
    this.oldCandiesAvailableWei = this.web3Service.getWeb3().utils.fromWei(oldCandiesEarned);
    this.hasOldCandies = BigNumber.from(oldCandiesEarned).gt(BigNumber.from("0"));

    let ticketEarnedLP = await this.stakingRewardsLPService.contract.methods.earned(this.wallet).call();
    this.ticketsAvailableLP = parseFloat(this.web3Service.getWeb3().utils.fromWei(ticketEarnedLP)).toFixed(5);
    this.ticketsAvailableWeiLP = this.web3Service.getWeb3().utils.fromWei(ticketEarnedLP)

    let lotteryId = await this.lotteryService.contract.methods.lotteryId().call();
    this.haveParticipated = await this.getTicketCountInLottery(lotteryId - 1) > 0;

    this.ticketsPlayed = await this.lotteryService.contract.methods.getTicketsInLottery(lotteryId).call();
    this.ticketsPlayedUser = await this.lotteryService.contract.methods.balanceOf(this.wallet).call();

    this.playersInLottery = await this.lotteryService.contract.methods.getPlayersInLottery(lotteryId).call();

    this.rewardRate = BigNumber.from(await this.stakingRewardsService.contract.methods.rewardRate().call());
    this.rewardRateLP = BigNumber.from(await this.stakingRewardsLPService.contract.methods.rewardRate().call());

    this.weeklyRewardRate = this.getV4WeeklyRewardRate()

    if (this.rewardRate.eq(0))
      this.accumulationStarted = false;

    this.winningClaims = await this.getWinningClaims();
    this.noWin = !this.hasWonInLastLottery();
    if (this.lootboxesObject[this.wallet]) {
      this.hasLootboxes = true;
    } else {
      this.hasLootboxes = false;
    }

    if (this.kmonStakedOld > 0) {
      this.haveMigrated = false;
    } else {
      this.haveMigrated = true;
    }

    if (this.winningClaims.length > 0) {
      //analytics.track("played lottery",{result:"won"})
      this.haveWon = true;
    } else {
      //analytics.track("played lottery",{result:"lost"})
      this.haveWon = false;
    }

    this.submittingWinners = await this.setSubmittingWinners(lotteryId);
  }

  setSubmittingWinners(lotteryId) {
    if (lotteryId == 0) {
      return false
    }

    const winningTrees = Object.entries(winners);
    const lastTree = winningTrees[lotteryId - 1];

    if (lastTree == undefined) {
      return true;
    }
    else if (Object.entries(lastTree[1].claims).length == 0) {
      return true;
    }
    else {
      return false;
    }
  }

  async collectEgg() {
    this.isLoadingCollect = true;
    const merkle = this.winningClaims.shift();

    await this.lotteryService.contract.methods.claimLotteryEgg(BigNumber.from(merkle.lotteryId), merkle.claim.index, merkle.address, merkle.claim.generation, merkle.claim.proof).send({
      from: this.wallet
    }).then((receipt) => {
      console.log(receipt);
      console.log(receipt.events);
      this.collectedKryptomon = true;
      this.isLoadingCollect = false;
    }).catch((err) => {
      console.log(err, 'err');
      this.toastService.genericError();
      this.isLoadingCollect = false;
      this.collectedKryptomon = false;
    });
  }


  indexOfMax(arr) {
    if (arr.length === 0) {
      return -1;
    }

    var max = arr[0];
    var maxIndex = 0;

    for (var i = 1; i < arr.length; i++) {
      if (arr[i] > max) {
        maxIndex = i;
        max = arr[i];
      }
    }

    return maxIndex;
  }

  closeShare() {
    this.showShare = false;
    this.collectedKryptomon = false;
  }


  getTicketCountInLottery(lotteryId): number {
    if (lotteryId < 0)
      return 0;

    if (lotteryId == 0) {
      return this.lotteryOldService.contract.methods.getUserTicketCountForLottery(lotteryId, this.wallet).call();
    }
    else {
      return this.lotteryService.contract.methods.getUserTicketCountForLottery(lotteryId, this.wallet).call();
    }
  }

  hasWonInLastLottery(): boolean {
    const winningTrees = Object.entries(winners);
    const lastTree = winningTrees[winningTrees.length - 1];

    if (Object.entries(lastTree[1].claims).length == 0)
      return true;

    return lastTree[1].claims[this.wallet];
  }

  async getWinningClaims() {
    // loop through each lottery merkle
    let claims = [];
    for (const [key, value] of Object.entries(winners)) {
      // find claims
      if (value.claims[this.wallet]) {
        claims.push({
          lotteryId: value.lotteryId,
          claim: value.claims[this.wallet],
          address: this.wallet
        })
      }
    }
    console.log(claims);

    // collect unclaimed eggs
    let unclaimedClaims = [];
    for (var i = 0; i < claims.length; i++) {
      var value = claims[i]
      const isClaimed = await this.lotteryService.contract.methods.isClaimed(BigNumber.from(value.lotteryId), value.claim.index).call();
      if (!isClaimed)
        unclaimedClaims.push(value);
    }

    return unclaimedClaims;
  }

  async checkLotteryStatus() {
    this.lotteryStatus = await this.lotteryService.contract.methods.lottery_state().call();
  }

  selectContent(index) {
    for (var i = 0; i < 3; i++) {
      if (i == index) {
        this.showContent[i] = true;
      } else {
        this.showContent[i] = false;
      }
    }
    this.selectedAmountUI = [false, false, false, false];
  }

  selectContentLP(index) {
    for (var i = 0; i < 3; i++) {
      if (i == index) {
        this.showContentLP[i] = true;
      } else {
        this.showContentLP[i] = false;
      }
    }
    this.selectedAmountUILP = [false, false, false, false];
  }

  selectAmountStake(index, value) {
    for (var i = 0; i < 4; i++) {
      if (i == index) {
        this.selectedAmountUI[i] = true;
      } else {
        this.selectedAmountUI[i] = false;
      }
    }

    this.kmonToBeStaked = (Math.floor(this.web3Service.getWeb3().utils.fromWei(this.balance) * value) / 100)
  }

  selectAmountStakeLP(index, value) {
    for (var i = 0; i < 4; i++) {
      if (i == index) {
        this.selectedAmountUILP[i] = true;
      } else {
        this.selectedAmountUILP[i] = false;
      }
    }

    this.lpToBeStaked = (Math.floor(this.web3Service.getWeb3().utils.fromWei(this.balanceLP) * value) / 100)
  }

  selectAmountWithdraw(index, value) {
    for (var i = 0; i < 4; i++) {
      if (i == index) {
        this.selectedAmountUI[i] = true;
      } else {
        this.selectedAmountUI[i] = false;
      }
    }

    this.kmonToBeWithdraw = (Math.floor(this.web3Service.getWeb3().utils.fromWei(this.kmonStakedWei.toString()) * value) / 100)
  }

  selectAmountWithdrawLP(index, value) {
    for (var i = 0; i < 4; i++) {
      if (i == index) {
        this.selectedAmountUILP[i] = true;
      } else {
        this.selectedAmountUILP[i] = false;
      }
    }

    this.lpToBeWithdraw = (Math.floor(this.web3Service.getWeb3().utils.fromWei(this.lpStakedWei.toString()) * value) / 100)
  }

  checkPlay() {
    let ticketToBePlayed = this.rangeValue == 100 ? this.ticketsAvailableWei : (this.ticketsAvailableWei * this.rangeValue / 100).toString();
    this.selectedTicketPlayed = Math.floor(parseFloat(ticketToBePlayed));
    if (this.selectedTicketPlayed > 0) {
      this.playDisabled = false;
    } else {
      this.playDisabled = true;
    }
  }

  checkPlayLP() {
    let ticketToBePlayed = this.rangeValueLP == 100 ? this.ticketsAvailableWeiLP : (this.ticketsAvailableWeiLP * this.rangeValueLP / 100).toString();
    this.selectedTicketPlayed = Math.floor(parseFloat(ticketToBePlayed));
    if (this.selectedTicketPlayed > 0) {
      this.playDisabledLP = false;
    } else {
      this.playDisabledLP = true;
    }
  }

  playTicket() {

    let ticketToBePlayed = this.rangeValue == 100 ? this.ticketsAvailableWei : (this.ticketsAvailableWei * this.rangeValue / 100).toString();

    if (Math.floor(parseFloat(ticketToBePlayed)) > 0) {
      this.isLoading = true;
      let ticketToBePlayedWei = this.web3Service.getWeb3().utils.toWei(ticketToBePlayed)
      this.stakingRewardsService.contract.methods.enterLottery(ticketToBePlayedWei).send({
        from: this.wallet
      }).then((result) => {
        if (result.events.EnteredLottery !== undefined) {
          analytics.track("played lottery", { amount: ticketToBePlayed })
          this.rangeValue = 0;
          this.checkBalance()
        } else {
          this.toastService.genericError();
          console.log('error');
          this.isLoading = false;
        }
        this.isLoading = false;
      }, (error) => {
        this.toastService.genericError();
        console.log(error)
        this.isLoading = false;
      })
    }
  }

  playTicketLP() {

    let ticketToBePlayed = this.rangeValue == 100 ? this.ticketsAvailableWeiLP : (this.ticketsAvailableWeiLP * this.rangeValueLP / 100).toString();

    if (Math.floor(parseFloat(ticketToBePlayed)) > 0) {
      this.isLoadingLP = true;
      let ticketToBePlayedWei = this.web3Service.getWeb3().utils.toWei(ticketToBePlayed)
      this.stakingRewardsLPService.contract.methods.enterLottery(ticketToBePlayedWei).send({
        from: this.wallet
      }).then((result) => {
        if (result.events.EnteredLottery !== undefined) {
          this.rangeValueLP = 0;
          this.checkBalance()
        } else {
          console.log('error');
          this.toastService.genericError();
          this.isLoadingLP = false;
        }
        this.isLoadingLP = false;
      }, (error) => {
        console.log(error)
        this.toastService.genericError();
        this.isLoadingLP = false;
      })
    }
  }


  async checkAllowance() {
    this.isLoading = true;
    let allowance = await this.tokenService.contract.methods.allowance(this.wallet, this.contractsService.getContractAddress(eContracts.StakingRewards)).call();
    console.log(allowance)
    if (BigNumber.from(allowance).gt(BigNumber.from("10000000000000000000000000"))) {
      this.isApproved = true;
      this.isLoading = false;
    } else {
      this.isApproved = false;
      this.isLoading = false;
    }
  }

  async checkAllowanceLP() {
    this.isLoadingLP = true;
    let allowance = await this.liquidityProviderService.contract.methods.allowance(this.wallet, this.stakingRewardsLPService.contract._address).call();
    console.log(allowance)
    if (allowance > 0) {
      this.isApprovedLP = true;
      this.isLoadingLP = false;
    } else {
      this.isApprovedLP = false;
      this.isLoadingLP = false;
    }
  }

  async giveAllowance() {
    this.isLoading = true;
    this.tokenService.contract.methods.approve(this.contractsService.getContractAddress(eContracts.StakingRewards), this.web3Service.getWeb3().utils.toWei('999999999999')).send({
      from: this.wallet
    }).then((result) => {
      if (result.events.Approval !== undefined) {
        this.isApproved = true;
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.isApproved = false;
      }
    }, (error) => {
      //console.log(error)
      this.toastService.genericError();
      this.isLoading = false;
      this.isApproved = false;
    })
  }

  async giveAllowanceLP() {
    this.isLoadingLP = true;
    this.liquidityProviderService.contract.methods.approve(this.stakingRewardsLPService.contract._address, this.web3Service.getWeb3().utils.toWei('999999999999')).send({
      from: this.wallet
    }).then((result) => {
      if (result.events.Approval !== undefined) {
        this.isApprovedLP = true;
        this.isLoadingLP = false;
      } else {
        this.isLoadingLP = false;
        this.isApprovedLP = false;
      }
    }, (error) => {
      this.toastService.genericError();
      //console.log(error)
      this.isLoadingLP = false;
      this.isApprovedLP = false;
    })
  }

  async migrateCandies() {
    this.isLoading = true;
    this.stakingRewardsService.contract.methods.migrateTickets().send({
      from: this.wallet
    }).then((result) => {
      this.checkBalance();
      this.isLoading = false;
    });
  }

  async migrateKMON() {

    this.kmonToBeWithdraw = this.kmonStakedOld;
    this.isLoading = true;
    this.migrationRunning = true;
    let kmonToBeWithdrawWei = this.web3Service.getWeb3().utils.toWei(this.kmonToBeWithdraw.toString());
    this.stakingRewardsOldService.contract.methods.withdraw(kmonToBeWithdrawWei).send({
      from: this.wallet
    }).then((result) => {
      console.log(result)
      if (result.events.Withdrawn !== undefined) {
        this.kmonToBeStaked = this.kmonToBeWithdraw
        let kmonToBeStakedWei = this.web3Service.getWeb3().utils.toWei(this.kmonToBeStaked.toString());
        this.stakingRewardsService.contract.methods.stake(kmonToBeStakedWei).send({
          from: this.wallet
        }).then((result) => {
          console.log(result)

          if (result.events.Staked !== undefined) {
            this.checkBalance();
            this.kmonToBeStaked = 0;
            this.kmonToBeWithdraw = 0;
            this.migrationRunning = false;
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.migrationRunning = false;
          }
        }, (error) => {
          console.log(error)
          this.isLoading = false;
          this.migrationRunning = false;
        })
      } else {
        this.isLoading = false;
        this.migrationRunning = false;
      }
    }, (error) => {
      console.log(error)
      this.isLoading = false;
      this.migrationRunning = false;
    })

  }

  stakeKMON() {
    if (this.kmonToBeStaked > 0 && this.kmonToBeStaked <= this.kmonBalance) {
      this.isLoading = true;
      let kmonToBeStakedWei = this.web3Service.getWeb3().utils.toWei(this.kmonToBeStaked.toString());
      console.log(this.wallet)
      this.stakingRewardsService.contract.methods.stake(kmonToBeStakedWei).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Staked !== undefined) {
          this.checkBalance();
          this.kmonToBeStaked = 0;
          analytics.track("staked kmon", { amount: this.kmonToBeStaked })
        } else {
          this.toastService.genericError();
          this.isLoading = false;
        }
        this.isLoading = false;
      }, (error) => {
        this.toastService.genericError();
        console.log(error)
        this.isLoading = false;
      })
    }
  }

  stakeLP() {
    if (this.lpToBeStaked > 0 && this.lpToBeStaked <= this.lpBalance) {
      this.isLoadingLP = true;
      let lpToBeStakedWei = this.web3Service.getWeb3().utils.toWei(this.lpToBeStaked.toString());
      this.stakingRewardsLPService.contract.methods.stake(lpToBeStakedWei).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Staked !== undefined) {
          this.checkBalance();
          this.lpToBeStaked = 0;
        } else {
          this.toastService.genericError();
          this.isLoadingLP = false;
        }
        this.isLoadingLP = false;
      }, (error) => {
        this.toastService.genericError();
        console.log(error)
        this.isLoadingLP = false;
      })
    }
  }

  withdrawKMONFromOld() {
    this.kmonToBeWithdraw = this.kmonStakedOld;
    this.isLoading = true;
    let kmonToBeWithdrawWei = this.web3Service.getWeb3().utils.toWei(this.kmonToBeWithdraw.toString());
    this.stakingRewardsOldService.contract.methods.withdraw(kmonToBeWithdrawWei).send({
      from: this.wallet
    }).then((result) => {
      console.log(result)
      if (result.events.Withdrawn !== undefined) {
        this.checkBalance();
        this.kmonToBeWithdraw = 0;
      } else {
        this.isLoading = false;
      }
      this.isLoading = false;
    }, (error) => {
      console.log(error)
      this.isLoading = false;
    })
  }

  withdrawKMON() {
    if (this.kmonToBeWithdraw > 0 && this.kmonToBeWithdraw <= this.kmonStaked) {
      this.isLoading = true;
      let kmonToBeWithdrawWei = this.web3Service.getWeb3().utils.toWei(this.kmonToBeWithdraw.toString());
      this.stakingRewardsService.contract.methods.withdraw(kmonToBeWithdrawWei).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Withdrawn !== undefined) {
          analytics.track("unstaked kmon", { amount: this.kmonToBeWithdraw })
          this.checkBalance();
          this.kmonToBeWithdraw = 0;
        } else {
          this.toastService.genericError();
          this.isLoading = false;
        }
        this.isLoading = false;
      }, (error) => {
        this.toastService.genericError();
        console.log(error)
        this.isLoading = false;
      })
    }
  }

  withdrawLP() {
    if (this.lpToBeWithdraw > 0 && this.lpToBeWithdraw <= this.lpStaked) {
      this.isLoadingLP = true;
      let lpToBeWithdrawWei = this.web3Service.getWeb3().utils.toWei(this.lpToBeWithdraw.toString());
      this.stakingRewardsLPService.contract.methods.withdraw(lpToBeWithdrawWei).send({
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Withdrawn !== undefined) {
          this.checkBalance();
          this.lpToBeWithdraw = 0;
        } else {
          this.toastService.genericError();
          this.isLoadingLP = false;
        }
        this.isLoadingLP = false;
      }, (error) => {
        this.toastService.genericError();
        console.log(error)
        this.isLoadingLP = false;
      })
    }
  }

  formatNumber(number): number {
    return Math.floor(number * 100) / 100
  }

  ngOnInit(): void {
  }

  getMyRewardRateFormatted(seconds: number,
    decimals: number): string {
    let rewardRate = this.getMyRewardRate(seconds, decimals);
    return parseFloat(this.web3Service.getWeb3().utils.fromWei(rewardRate.toString())).toFixed(4);
  }

  getMyRewardRateFormattedLP(seconds: number,
    decimals: number): string {
    let rewardRate = this.getMyRewardRateLP(seconds, decimals);
    return parseFloat(this.web3Service.getWeb3().utils.fromWei(rewardRate.toString())).toFixed(4);
  }

  getMyRewardRate(seconds: number,
    decimals: number): BigNumber {
    const kmonRewardRate = this.getHypotheticalRewardRate(this.kmonStakedWei, this.totalKMONStakedWei, seconds, decimals, this.rewardRate);
    return kmonRewardRate;
  }

  getMyRewardRateLP(seconds: number,
    decimals: number): BigNumber {
    const lpRewardRate = this.getHypotheticalRewardRate(this.lpStakedWei, this.totalLPStakedWei, seconds, decimals, this.rewardRateLP);
    return lpRewardRate;
  }

  getV4WeeklyRewardRate() {
    return parseFloat(this.web3Service.getWeb3().utils.fromWei(this.getHypotheticalRewardRate(this.totalKMONStakedWei, this.totalKMONStakedWei, 60 * 60 * 24 * 7, 1, this.rewardRate).toString())).toFixed(0);
  }

  getV4WeeklyRewardRateLP() {
    return parseFloat(this.web3Service.getWeb3().utils.fromWei(this.getHypotheticalRewardRate(this.totalLPStakedWei, this.totalLPStakedWei, 60 * 60 * 24 * 7, 1, this.rewardRateLP).toString())).toFixed(0);
  }

  getHypotheticalRewardRate(stakedAmount: BigNumber,
    totalStakedAmount: BigNumber,
    seconds: number,
    decimals: number,
    rewardRate: BigNumber): BigNumber {
    let amount = BigNumber.from("0");
    if (totalStakedAmount.gt(BigNumber.from("0"))) {
      const rr = rewardRate.mul(BigNumber.from(seconds));
      const sa = stakedAmount;
      const tsa = totalStakedAmount;
      const urr = rr.mul(sa).mul(BigNumber.from(decimals));
      amount = urr.div(tsa);
    }
    return amount;

  }

  getWinningProbability(ticketsBet, totalTicketsBet, players): string {
    if (players == 0)
      return "0";
    const eggsAvailable = Math.floor(players / 10);

    const meanTicketsBet = (totalTicketsBet - ticketsBet) / (players - 1);

    const totalLessMean = totalTicketsBet - (eggsAvailable * meanTicketsBet / 2)

    const probability = (1 - ((totalLessMean - ticketsBet) / totalLessMean) ** eggsAvailable) * 100;

    return probability.toFixed(2);
  }

  gotoDashboard() {
    this.router.navigate(['/']);
  }

  gotoItems() {
    window.open("https://market.kryptomon.co/items");
  }

  openStake() {
    document.getElementById("popupOverlay").style.display = "flex";
    document.getElementById("stakePopup").style.display = "flex";
  }
  openStakeLP() {
    console.log("click")
    document.getElementById("popupOverlayLP").style.display = "flex";
    document.getElementById("stakeLPPopup").style.display = "flex";
  }
  openUnstake() {
    document.getElementById("unstakePopup").style.display = "flex";
    document.getElementById("popupOverlay").style.display = "flex";
  }
  openUnstakeLP() {
    document.getElementById("unstakeLPPopup").style.display = "flex";
    document.getElementById("popupOverlayLP").style.display = "flex";
  }
  closeStake() {
    document.getElementById("popupOverlay").style.display = "none";
    document.getElementById("stakePopup").style.display = "none";
  }
  closeStakeLP() {
    document.getElementById("popupOverlayLP").style.display = "none";
    document.getElementById("stakeLPPopup").style.display = "none";
  }
  closeUnstake() {
    document.getElementById("popupOverlay").style.display = "none";
    document.getElementById("unstakePopup").style.display = "none"
  }
  closeUnstakeLP() {
    document.getElementById("popupOverlayLP").style.display = "none";
    document.getElementById("unstakeLPPopup").style.display = "none"
  }
}
